import { render, staticRenderFns } from "./RelatedPayee.vue?vue&type=template&id=d26116a0&scoped=true&"
import script from "./RelatedPayee.vue?vue&type=script&lang=js&"
export * from "./RelatedPayee.vue?vue&type=script&lang=js&"
import style0 from "./RelatedPayee.vue?vue&type=style&index=0&id=d26116a0&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d26116a0",
  null
  
)

export default component.exports